<hub-loading-spinner *ngIf="loading"></hub-loading-spinner>
<hub-browser-warning></hub-browser-warning>
<div [hidden]="loading">
  <router-outlet></router-outlet>
</div>
